export default __webpack_public_path__ + "static/media/arrow-address.aef4893f.png";